




































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";
import { storeDokter } from "@/store/modules/dokter";
import { storeResumeHemodialisa } from "@/store/modules/ResumeHemodialisaStore";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import ResumeHemodialisaSvc from "@/services/ResumeHemodialisa";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import http from "@/axios/http-common";
import moment from "moment";
import { confirmRemove } from "@/utility/CommonHelper";

@Component({
  components: {
    CardModalTtd
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardResumeHemodialisa extends Vue {
  @Prop() register!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  editing = false;
  saving = false;
  deleting = false;
  modalTtdOpen = false;

  menuTglPeriksa = false;
  menuTglSjp = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  diagResults: any[] = [];
  diagSearching = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  diagSearchTimer: any = null;

  rules = {
    required: v => !!v || "Wajib diisi"
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any = this.emptyForm();

  emptyForm() {
    const reg = RegisterKunjungan.register;
    const pasien = storePasien.identitasPasien;
    const today = localISODate();

    // Tanggal periksa dari register (format dd-mm-yyyy → yyyy-mm-dd)
    let tglPeriksa = today;
    if (reg?.tgl) {
      const parts = reg.tgl.split("-");
      if (parts.length === 3 && parts[0].length === 2) {
        tglPeriksa = `${parts[2]}-${parts[1]}-${parts[0]}`;
      } else {
        tglPeriksa = reg.tgl;
      }
    }

    // No kartu JKN dari data asuransi register
    const noKartu = pasien?.register?.asr?.nomor || "";

    // Asal rujukan dari register
    const asalRujukan = reg?.asr_n || "";

    // DPJP: dari register dokter, atau user yang login
    const dpjpId = reg?.dokter?.id || this.stateuser?.id || null;

    return {
      register_id: this.register,
      pasien_rm: this.$route.params.rm || "",
      tanggal_periksa: tglPeriksa,
      no_kartu_jkn: noKartu,
      tanggal_sjp: null,
      asal_rujukan: asalRujukan,
      no_rujukan: "",
      tujuan_rujukan: "Klinik",
      rujukan_intern: "",
      cara_pulang: "pulang",
      rujukan_ke: "",
      status_kasus: "lama",
      catatan_klinis: "",
      dpjp_id: dpjpId,
      diagnosis: [
        { urut: 0, kode: "N18", nama: "CKD Stage V", searchText: "", selectedDiag: null }
      ],
      tindakan: [
        { urut: 1, kode: "HMD 13", nama: "HD dengan dialiser baru/tanpa reuse", tanggal: tglPeriksa },
        { urut: 2, kode: "HMD 21", nama: "Intermediate Care", tanggal: tglPeriksa },
        { urut: 3, kode: "1700", nama: "Pemeriksaan dr.", tanggal: tglPeriksa }
      ]
    };
  }

  get item() {
    return storeResumeHemodialisa.item;
  }

  get loading() {
    return storeResumeHemodialisa.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get listDokter() {
    return storeDokter.listAll;
  }

  get isSigned() {
    return this.item && this.item.signed_at;
  }

  get canSign() {
    if (this.readOnly) return false;
    return (
      this.item &&
      !this.isSigned &&
      this.stateuser.profesi === "Dokter" &&
      this.stateuser.id == this.item.dpjp_id
    );
  }

  get canEdit() {
    if (this.readOnly) return false;
    return this.item && !this.isSigned;
  }

  get canRemove() {
    if (this.readOnly) return false;
    if (!this.item) return false;
    return !alasanTtdMengunciHapus(
      this.item.user_id,
      [{ ditandatangani: this.isSigned, penandaTanganId: this.item.dpjp_id }],
      this.stateuser && this.stateuser.id
    );
  }

  // Diagnosis ICD-10 search
  searchDiagnosis(term: string) {
    if (!term || term.length < 2) return;

    clearTimeout(this.diagSearchTimer);
    this.diagSearchTimer = setTimeout(() => {
      this.diagSearching = true;
      http
        .getDataParam("/referensi/diagnosis-icd/search", { params: { term } })
        .then(res => {
          this.diagResults = res.data;
        })
        .finally(() => {
          this.diagSearching = false;
        });
    }, 500);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDiagSelect(idx: number, selected: any) {
    if (selected) {
      this.form.diagnosis[idx].kode = selected.kddx;
      this.form.diagnosis[idx].nama = selected.dx;
    }
  }

  addDiagnosis() {
    const nextUrut = this.form.diagnosis.length;
    this.form.diagnosis.push({
      urut: nextUrut,
      kode: "",
      nama: "",
      searchText: "",
      selectedDiag: null
    });
  }

  removeDiagnosis(idx: number) {
    this.form.diagnosis.splice(idx, 1);
    // Re-number sekunder
    this.form.diagnosis.forEach((d, i) => {
      if (i > 0) d.urut = i;
    });
  }

  addTindakan() {
    const nextUrut = this.form.tindakan.length + 1;
    const today = localISODate();
    this.form.tindakan.push({
      urut: nextUrut,
      kode: "",
      nama: "",
      tanggal: today
    });
  }

  removeTindakan(idx: number) {
    this.form.tindakan.splice(idx, 1);
    this.form.tindakan.forEach((t, i) => {
      t.urut = i + 1;
    });
  }

  initForm() {
    this.form = this.emptyForm();
    this.editing = true;
  }

  startEdit() {
    this.populateFormFromItem();
    this.editing = true;
  }

  populateFormFromItem() {
    const it = this.item;
    this.form = {
      register_id: it.register_id,
      pasien_rm: it.pasien_rm,
      tanggal_periksa: it.tanggal_periksa,
      no_kartu_jkn: it.no_kartu_jkn,
      tanggal_sjp: it.tanggal_sjp,
      asal_rujukan: it.asal_rujukan || "",
      no_rujukan: it.no_rujukan || "",
      tujuan_rujukan: it.tujuan_rujukan || "Klinik",
      rujukan_intern: it.rujukan_intern || "",
      cara_pulang: it.cara_pulang,
      rujukan_ke: it.rujukan_ke || "",
      status_kasus: it.status_kasus,
      catatan_klinis: it.catatan_klinis || "",
      dpjp_id: it.dpjp_id,
      diagnosis: (it.diagnosis || []).map(d => ({
        urut: d.urut,
        kode: d.kode || "",
        nama: d.nama || "",
        searchText: "",
        selectedDiag: null
      })),
      tindakan: (it.tindakan || []).map(t => ({
        urut: t.urut,
        kode: t.kode || "",
        nama: t.nama || "",
        tanggal: t.tanggal || ""
      }))
    };
  }

  buildPayload() {
    return {
      register_id: this.form.register_id || this.register,
      pasien_rm: this.form.pasien_rm,
      tanggal_periksa: this.form.tanggal_periksa,
      no_kartu_jkn: this.form.no_kartu_jkn,
      tanggal_sjp: this.form.tanggal_sjp || null,
      asal_rujukan: this.form.asal_rujukan || null,
      no_rujukan: this.form.no_rujukan || null,
      tujuan_rujukan: this.form.tujuan_rujukan || "Klinik",
      rujukan_intern: this.form.rujukan_intern || null,
      cara_pulang: this.form.cara_pulang,
      rujukan_ke: this.form.cara_pulang === "dirujuk" ? this.form.rujukan_ke : null,
      status_kasus: this.form.status_kasus,
      catatan_klinis: this.form.catatan_klinis || null,
      dpjp_id: this.form.dpjp_id,
      diagnosis: this.form.diagnosis.map(d => ({
        urut: d.urut,
        kode: d.kode || null,
        nama: d.nama || null
      })),
      tindakan: this.form.tindakan.map(t => ({
        urut: t.urut,
        kode: t.kode || null,
        nama: t.nama || null,
        tanggal: t.tanggal || null
      }))
    };
  }

  async simpan() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const formRef = this.$refs.form as any;
    if (formRef && !formRef.validate()) return;

    this.saving = true;
    try {
      const payload = this.buildPayload();

      if (this.item && this.editing) {
        await ResumeHemodialisaSvc.update(this.item.id, payload);
        appModule.NoticeDelay("Berhasil update Resume Hemodialisa");
      } else {
        await ResumeHemodialisaSvc.create(payload);
        appModule.NoticeDelay("Berhasil simpan Resume Hemodialisa");
      }

      this.editing = false;
      await storeResumeHemodialisa.fetchByRegister(this.register);
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
  }

  batal() {
    this.editing = false;
    if (this.item) {
      this.populateFormFromItem();
    }
  }

  async hapus() {
    if (!this.canRemove) return;
    if (!confirmRemove("Resume Hemodialisa")) return;
    if (this.deleting) return;

    this.deleting = true;
    try {
      await ResumeHemodialisaSvc.destroy(this.item.id);
      appModule.NoticeDelay("Berhasil hapus Resume Hemodialisa");
      await storeResumeHemodialisa.fetchByRegister(this.register);
    } catch (e) {
      // Error handled by service
    }
    this.deleting = false;
  }

  async doSign(password: string) {
    appModule.setLoading(true);
    try {
      const resp = await ResumeHemodialisaSvc.sign(this.item.id, { password });
      if (resp.data.status == 1) {
        this.modalTtdOpen = false;
        appModule.addMsgTtd("");
        appModule.NoticeDelay("Berhasil menandatangani Resume Hemodialisa");
        await storeResumeHemodialisa.fetchByRegister(this.register);
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtdOpen = true;
      }
    } catch (e) {
      const msg = e?.response?.data?.message || "Gagal menandatangani";
      appModule.addMsgTtd(msg);
      this.modalTtdOpen = true;
    }
    appModule.setLoading(false);
  }

  cetakPdf() {
    ResumeHemodialisaSvc.print(this.item.id);
  }

  caraPulangLabel(val: string) {
    const map = {
      pulang: "Pulang ke Rumah",
      dirujuk: "Dirujuk",
      pulang_paksa: "Pulang Paksa",
      meninggal: "Meninggal",
      rawat_inap: "Rawat Inap"
    };
    return map[val] || val;
  }

  formatDateTime(date: string) {
    return date ? moment(date).format("DD MMMM YYYY HH:mm:ss") : "";
  }
}
